HomeSceneButton = xClass("HomeSceneButton", cc.Node)
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
HomeSceneButton.prototype.ctor = function (text, image, swallowTouch = true, needStoken = true, promptType = PromptTypeDef.withLabel, needbg = true, animClass) {
    let self = this
    self.swallowTouch = swallowTouch
    self.promptType = promptType
    cc.Node.prototype.ctor.call(self)
    self.text = text
    self.needStoken = needStoken
    self.needbg = needbg
    self.animClass = animClass
    self.node = cc.Node.create()
    self.image = image
    self.init()
}
HomeSceneButton.prototype.setOnRedDotChange = function (onRedDotChange) {
    let self = this
    self.onRedDotChange = onRedDotChange
}
HomeSceneButton.prototype.initRewardText = function () {
    let self = this
    self.rewardText = cc.Sprite.createWithSpriteFrameName("homeScene/rewardtxt1.png")
    self.addChild(self.rewardText, 0, "reward")
    self.rewardText.setVisible(false)
}
HomeSceneButton.prototype.setRewardVisible = function (visible) {
    let self = this
    self.rewardText.setVisible(visible)
}
HomeSceneButton.prototype.init = function () {
    let self = this
    let btn = UIButton.create(self.node, self.swallowTouch)
    self.btn = btn
    btn.on(UIButtonEvent.Click, function (evt) {
        self.onCick(evt)
    })
    if (self.text && typeof self.text !== "object") {
        if (self.needStoken) {
            self.text = cc.LabelTTF.create(self.text, FONT_DEF.microsoftYahei_24_blueStroke)
        }else {
            self.text = cc.Label.createWithSystemFont(self.text, "Arial", 24)
        }
    }
    if (self.needbg) {
        self.bg = cc.Sprite.createWithSpriteFrameName("homeScene/icon_bg.png")
        self.node.addChild(self.bg, -1, "bg")
    }
    let imageNode = null
    if (self.image != null) {
        if (string.ends(self.image, ".csb")) {
            imageNode = cc.CSLoader.createNode(self.image)
            self.imageNode = imageNode
            self.node.addChild(imageNode, 0, "icon")
            setTimeout(() => {
                self.initAfter()
                if (self.customInit) {
                    self.customInit()
                }
            }, 0);
        } else if (cc.spriteFrameCache.getSpriteFrame(self.image)) {
            imageNode = cc.Sprite.createWithSpriteFrameName(self.image)
            self.imageNode = imageNode
            self.node.addChild(imageNode, 0, "icon")
            setTimeout(() => {
                self.initAfter()
                if (self.customInit) {
                    self.customInit()
                }
            }, 0);
        }else {
            imageNode = cc.Sprite.create()
            self.image = getRealResourceName(self.image)
            self.imageNode = imageNode
            cc.loader.autoLoad(self.image, function () {
                let texture = cc.textureCache.addImage(self.image)
                imageNode._renderCmd._setTexture(texture);
                imageNode.initWithFile(self.image)
                setTimeout(() => {
                    self.initAfter()
                    if (self.customInit) {
                        self.customInit()
                    }
                })
            })
            self.node.addChild(imageNode, 0, "icon")
        }
    }
    self.node.addChild(self.text, 0, "txt")
    self.animClass ? self.animClass.create(self.node) : ButtonPushBounceAnim.create(self.node)
    self.addChild(self.node)
    self.initPrompt()
}
HomeSceneButton.prototype.initAfter = function () {
    let self = this
    let bgNode = null
    if (self.needbg) {
        bgNode = self.bg
    }else {
        bgNode = self.imageNode
    }

    let textSize = self.text.getContentSize()
    let textPosY = -bgNode._contentSize.height / 2 + textSize.height / 2 * 0.86;
    // if (META.platform === XcloverPlatform.wechatgame) {
        textPosY = textPosY - textSize.height / 2
    // }
    if(window.qq && cc.sys.os === cc.sys.OS_ANDROID)
        textPosY -= 8

    self.text.y = textPosY
    let bgSize = bgNode.getContentSize()
    self.node.setContentSize(bgSize)

    this.refreshPromptPos();
}
HomeSceneButton.prototype.initPrompt = function () {
    let self = this
    if (this.promptType === PromptTypeDef.noDot) {
        return
    }
    if (this.promptType === PromptTypeDef.withLabel ) {
        this.prompt = require("clover/scene/component/homescene/PromptTip").create()
    }else if (this.promptType === PromptTypeDef.justDot ) {
        // this.prompt = cc.Sprite.createWithSpriteFrameName("h5library/reddot.png")
        this.prompt = cc.Sprite.createWithSpriteFrameName("uilibrary/btn_prompt.png")
    } else if (this.promptType === PromptTypeDef.both) {        
        this.prompt = require("clover/scene/component/homescene/PromptTipAndDot").create()
    } else if (this.promptType === PromptTypeDef.newTip) {
        this.prompt = cc.Sprite.createWithSpriteFrameName("commonLib/common_reddot_2.png");
    }
    this.prompt.setScale(0.7)
    // this.addChild(this.prompt)
    self.node.addChild(this.prompt)
    this.prompt.setVisible(false)
}
/**
 * 设置提示类型
 */
HomeSceneButton.prototype.setPromptType = function(promptType) {
    if(this.promptType != promptType) {
        this.promptType = promptType;
        this.prompt.removeFromParent();
        this.initPrompt();
        this.refreshPromptPos();
    }
    this.prompt &&this.prompt.setVisible(true);
}

HomeSceneButton.prototype.refreshPromptPos = function() {
    if (this.promptType !== PromptTypeDef.noDot && this.prompt) {
        let bgSize = this.node.getContentSize();
        let size = this.prompt.getContentSize()
        let pos = cc.p(bgSize.width / 2 / Math.sqrt(2) + size.width * 0.15, bgSize.height / 2 / Math.sqrt(2) + size.height * 0.15)
        this.prompt.setPosition(pos);
        this.promptPos = pos;
    }
}

HomeSceneButton.prototype.setPromptNum = function (num) {
    this.prompt.setNum(num)
}
HomeSceneButton.prototype.onCick = function () {
    cc.log("implement me")
}
HomeSceneButton.prototype.addToHomeScene = function (pos) {
    pos = pos || ICON_TYPE.kRight
    let HomeScene = require("clover/scene/HomeScene")
    HomeScene.getInstance().btnLayer.addBtnToSelf(icon, pos)
}

module.exports = HomeSceneButton